module.exports = __webpack_public_path__ + "img/bj-1.bea41943.png";